import styled from 'styled-components'
import { withTheme } from '@material-ui/styles'

export const SpinnerWrapper = withTheme(styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ padding, theme }) => padding || theme.spacing(2)}px;
  box-sizing: border-box;
`)
